"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePluralIfNecessary = exports.makePlural = exports.makeSingular = void 0;
/**
 * Returns the English singular form of a plural word.
 *
 * @param plural
 * @return string
 */
var makeSingular = function (plural) {
    if (!plural) {
        return "";
    }
    var plurals = { ies: "y", es: "", s: "" };
    for (var pluralEnding in plurals) {
        var singularEnding = plurals[pluralEnding];
        plural = plural.replace(new RegExp("/" + pluralEnding + "$/i"), singularEnding);
    }
    return plural;
};
exports.makeSingular = makeSingular;
/**
 * Returns the English plural form of a singular word.
 *
 * @param singular
 * @return string
 */
var makePlural = function (singular) {
    if (!singular) {
        return "";
    }
    var singulars = {
        ss: "sses",
        ey: "eys",
        day: "days",
        ch: "ches",
        s: "ses",
        x: "xes",
        y: "ies",
    };
    for (var singularEnding in singulars) {
        var pluralEnding = singulars[singularEnding];
        var reg = new RegExp(singularEnding + "$", "i");
        if (singular.match(reg)) {
            return singular.replace(reg, pluralEnding);
        }
    }
    return singular + "s";
};
exports.makePlural = makePlural;
var makePluralIfNecessary = function (singular, itemCount) {
    return itemCount === 1 ? singular : exports.makePlural(singular);
};
exports.makePluralIfNecessary = makePluralIfNecessary;
//# sourceMappingURL=Plurals.js.map